/**
 * Created by Ding on 13/04/2017.
 */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { Menu, Dropdown, Tabs, Icon, message } from 'antd';
import cookie from 'react-cookie';
import { ajaxGet } from '../../utils/ajax';
import UpdateAlert from '../../common/updateAlert/UpdateAlert';
// import FeedbackModal from '../../components/FeedbackModal';
import DynamicMsg from '../../components/DynamicMsg'
// import FeedbackModal from './feedbackModal';
// import FeedbackModal from '../App/feedbackModal';

import '../../style/base.less';
import './hunter.less';

const TabPane = Tabs.TabPane;


export default class Hunter extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        children: PropTypes.object.isRequired,
    };

    state = {
        wxcode: 0,
        message: '',
        dynamicMsgShow: true,
        isMessageOpen: false,
        headerStype: {},
        messages: [
            { time: '2016.02.03', value: '招聘政策新动态1' },
            { time: '2016.02.03', value: '招聘政策新动态2' },
            { time: '2016.02.03', value: '招聘政策新动态3' },
            { time: '2016.02.03', value: '招聘政策新动态4' },
        ],
    };

    // showMessage = () => {
    //     this.setState({
    //         isMessageOpen: true,
    //     })
    // };

    closeMessage = () => {
        this.setState({
            isMessageOpen: false,
        });
    };

    logOut = (e) => {
        e.preventDefault();
        ajaxGet('/api/hunter/logout', {}, () => {
            message.success('注销成功！', 1, () => this.props.history.push('/login'));
        });
    };

    updateCallback = () => {
        try {
            const noticeNode = document.getElementById('js_notice_info_ct');
            const top = `${noticeNode.offsetHeight + 10}px`;
            this.setState({
                headerStype: {
                    position: 'absolute',
                    top,
                },
            });
        } catch (err) {
            console.log('err:', err);
        }
    };

    closeCallback = () => {
        this.setState({
            headerStype: {},
        });
    };



    onClose = () => {
        this.setState({
            dynamicMsgShow: false
        })
    }

    componentDidMount() {
        fetch('https://as.xiaojukeji.com/ep/as/conf?ns=recruit-tips&name=hunter')
        .then(data => data.json()).then(item => {
            let { data } = item
            if (data) {
                let [msg] = data
                let {params : {wxcode, message, show}} = msg
                this.setState({
                    message: message.replace('${message}', wxcode),
                    dynamicMsgShow: show !== 'false'
                })
            }
        })
    }


    render() {
        let { dynamicMsgShow, message } = this.state
        const menu = (
            <Menu>
                <Menu.Item>
                    <a href="" onClick={this.logOut}>注销</a>
                </Menu.Item>
            </Menu>
        );

        return (
            <div>
                <UpdateAlert updateCallback={this.updateCallback} closeCallback={this.closeCallback} type="hunter" />
                <div className="hunter-header" style={this.state.headerStype}>

                    <DynamicMsg
                        message={message}
                        show={dynamicMsgShow}
                        onClose={this.onClose}
                    />

                    <div className="hunter-header-content">
                        <Link to="/">
                            <div className="hunter-header-logo" />
                        </Link>
                        <span className="hunter-header-company">
                            {cookie.load('hunter_company')}
                        </span>


                        <div className="hunter-header-right">
                            <p
                                style={{
                                    display: 'inline-block',
                                    color: '#999',
                                    marginRight: '27px',
                                }}
                            >
                                联系我们：zhaopin@didiglobal.com
                            </p>
                            {/* <div
                                className="hunter-header-message-icon"
                                onClick={this.showMessage}
                            /> */}
                            <Dropdown style={{ display: 'inline-block' }} overlay={menu}>
                                <a href="" onClick={e => e.preventDefault()}>
                                    {cookie.load('cookie_user_zh')}
                                    <Icon type="down" />
                                </a>
                            </Dropdown>
                        </div>
                    </div>
                </div>

                <div className="hunter-page" style={{marginTop: (dynamicMsgShow ? 36 : 0)}}>
                    {this.props.children}
                </div>

                <div
                    className="hunter-message-wrapper"
                    style={{
                        display: this.state.isMessageOpen ? 'block' : 'none',
                    }}
                >
                    <Tabs
                        defaultActiveKey="1"
                        tabBarExtraContent={
                            <Icon
                                type="close"
                                onClick={this.closeMessage}
                                style={{ marginRight: '24px' }}
                            />
                        }
                        style={{ marginTop: '24px' }}
                    >
                        <TabPane tab="未读消息" key="1">
                            <ul>
                                {this.state.messages.map(item => (
                                    <li
                                        key={item.value}
                                        style={{
                                            padding: '20px 0 23px',
                                            borderBottom: 'solid 1px #e8e8e8',
                                        }}
                                    >
                                        <p style={{ fontSize: '14px' }}>{item.value}</p>
                                        <p style={{ color: '#a4a4a4' }}>{item.time}</p>
                                    </li>
                                ))}
                            </ul>
                        </TabPane>

                        <TabPane tab="已读消息" key="2">
                            <ul>
                                {this.state.messages.map(item => (
                                    <li
                                        key={item.value}
                                        style={{
                                            padding: '20px 0 23px',
                                            borderBottom: 'solid 1px #e8e8e8',
                                        }}
                                    >
                                        <p style={{ fontSize: '14px' }}>{item.value}</p>
                                        <p style={{ color: '#a4a4a4' }}>{item.time}</p>
                                    </li>
                                ))}
                            </ul>
                        </TabPane>
                    </Tabs>
                </div>
                {/* <FeedbackModal
                    channelCode="3"
                    ldap={cookie.load('cookie_user_en')}
                    name={cookie.load('cookie_user_zh')}
                /> */}
            </div>
        );
    }
}
